import type { Facets } from '@seek/chalice-types';
import { Box, Inline, Text } from 'braid-design-system';

import * as styles from './NudgePill.css';

interface NudgePillProps {
  label: string;
  count: number;
  isActive: boolean;
  id: string;
  isMobile: boolean;
  onClick: (id: string) => void;
  facetKey?: keyof Facets;
}

export const NudgePill = ({
  label,
  count,
  isActive,
  id,
  isMobile,
  onClick,
  facetKey,
}: NudgePillProps) => {
  const displayCounts = facetKey !== 'distinctTitle';

  return (
    <Box
      data-automation="displayPills"
      key={id}
      role="button"
      onClick={() => onClick(id)}
      className={{
        [styles.nudgePill]: displayCounts,
        [styles.nudgePillsWithoutCounts]: !displayCounts,
        [styles.selectedNudgePill]: isActive,
      }}
      background={isActive ? 'customDark' : 'customLight'}
    >
      <Inline space="xxsmall" alignY="center" align="center">
        <Text size={isMobile ? 'small' : 'standard'}>{label}</Text>
        {displayCounts && (
          <Box
            display="inline"
            background="positiveLight"
            paddingY="xxsmall"
            paddingX="xsmall"
            borderRadius="large"
          >
            <Text tone="positive" size="xsmall" weight="medium">
              {count > 99 ? '99+' : count}
            </Text>
          </Box>
        )}
      </Inline>
    </Box>
  );
};
